export default {
    requiredField: 'Field {{field}} is required.',
    shouldBeNumber: 'Field {{field}} should be number.',
    shouldBeString: 'Field {{field}}) should be string.',
    stringShouldHaveMinLength: "In field {{field}} use at least {{minLength}} $t(common:char, {'count': {{minLength}}}).",
    stringShouldHaveMaxLength: "In field {{field}} use max {{maxLength}} $t(common:char, {'count': {{maxLength}}}).",
    stringShouldHaveLength: "In field {{field}} user exactly {{length}} $t(common:char, {'count': {{length}}}).",
    numberMinValue: 'In field {{field}} use number higher or exact as {{min}}.',
    numberMaxValue: 'In field {{field}} use number lower or exact as {{max}}.',
    emailShouldContainAt: "Email should contain at - '@'.",
    emailShouldContainDomain: "Email should contain domain. For example '.cz' or '.com'.",
    emailShouldHaveValidFormat: "Email should have valid format. For example 'yourname@name.cz'",
    emailContainsDiacritics: 'Email should not contain any diacritic characters.',
    emailDomainContainsValidChars: 'Email should not contain any diacritic characters and illegal characters.',
    incorrectDateInserted: 'Incorrect date in field {{field}}.',
    incorrectMonthInserted: 'Mont of year in field {{field}} is incorrect.',
    incorrectYearInserted: 'Year in field {{field}} is incorrect.',
    incorrectDateFormat: 'Format of date in field {{field}} is incorrect. Please insert date in format {{format}}',
    dateNotBefore: 'Date in field {{field}} must be before {{before, DD.MM.YYYY}}.',
    dateNotAfter: 'Date in field {{field}} must be after{{after, DD.MM.YYYY}}.',
    birthNumberNotCorrect: 'Birth numbers is incorrect.',
    birthNumberContainsSlash: 'Please, remove slash in birth number.',
    icNotCorrect: 'IC is incorrect.',
    shouldHaveNoWhitespaces: '{{field}} shout not contain whitespaces.',
    shouldHaveNoPunctuation: '{{field}} shout not contain punctuation.',
    shouldHaveNoPunctuationStrict: 'Field {{field}} contain restricted characters.',
    shouldHaveOnlyDigits: 'Field {{field}} can contain only digits.',
    isAlphanumerical: 'Field {{field}} can contain only alphanumeric characters.',
    isAlphanumericalUpper: 'Field {{field}} can contain only upper case alphanumeric characters.',
    isAlphanumericalLower: 'Field {{field}} can contain only lower case alphanumeric characters.',
    onlyAllowedChars: 'Field {{field}} contain restricted characters.',
    companyNameIncorrect: 'Field {{field}} contain incorrect characters.',
    phoneIncorrect: 'Phone number is incorrect. Please insert 12 digits with + at beginning, or 9 digits.',
    wrongExtension: 'File does not have required extension',
    wrongSize: 'File size exceeded',
    wrongSizeDropzone: '<strong>{{fieldValueIndexed.name}}</strong> is too large ({{sizeMb, number(style: unit; unit: megabyte)}})',
    uploadTotalMaxSize: 'Total size of files exceeded (total: {{sizeMb, number(style: unit; unit: megabyte)}})',
    wrongExtensionDropzone: '<strong>{{fieldValueIndexed.name}}</strong> has unsupported extension',
    uploadHasError: 'Field {{field}} has invalid files.',
    incorrectVinFormat: 'Invalid VIN',
    incorrectVatFormat: 'Invalid VAT',
    zipNotCorrect: 'ZIP is incorrect.',
    uploadMaxNumOfFiles: "You can upload max {{numOfFiles}} $t(common:file, {'count': {{numOfFiles}}})."
};
